import { render, staticRenderFns } from "./WorkBasicIconDialog.vue?vue&type=template&id=605eb59e"
import script from "./WorkBasicIconDialog.vue?vue&type=script&lang=js"
export * from "./WorkBasicIconDialog.vue?vue&type=script&lang=js"
import style0 from "./WorkBasicIconDialog.vue?vue&type=style&index=0&id=605eb59e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports